import { render, staticRenderFns } from "./StepComponent.vue?vue&type=template&id=7b455534&scoped=true&"
import script from "./StepComponent.vue?vue&type=script&lang=js&"
export * from "./StepComponent.vue?vue&type=script&lang=js&"
import style0 from "./StepComponent.vue?vue&type=style&index=0&id=7b455534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b455534",
  null
  
)

export default component.exports